import { render, staticRenderFns } from "./TaskP.vue?vue&type=template&id=9a0ca1ae&scoped=true"
import script from "./TaskP.vue?vue&type=script&lang=ts"
export * from "./TaskP.vue?vue&type=script&lang=ts"
import style0 from "./TaskP.vue?vue&type=style&index=0&id=9a0ca1ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0ca1ae",
  null
  
)

export default component.exports